var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.title))]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }